<ion-header>
  <ion-toolbar style="padding-right: 15px">
    <div class="flex-space-between">
      <div class="flexed">
        <ion-list class="no-padding transparent-bg">
          <ion-item class="transparent-bg">
            <ion-label position="stacked"> Report Type </ion-label>
            <ion-button
              (click)="selectReportType()"
              fill="clear"
              size="full"
              class="btn-large no-margin"
              style="--padding-start: 0"
            >
              {{ getChartTypeLabel(chartType) }}
              <ion-icon
                name="chevron-down-outline"
                class="filter-button-caret"
              ></ion-icon>
            </ion-button>
          </ion-item>
        </ion-list>
      </div>

      <div class="flexed-align-center">
        <ion-button
          color="dark"
          fill="clear"
          class="button-dark-border"
          *ngIf="getSavedReport(savedReportId)"
          (click)="showSavedReportOptions(savedReportId)"
        >
          <ion-icon
            style="font-size: 0.8rem"
            name="ellipsis-vertical"
          ></ion-icon>
        </ion-button>
        <ion-button
          (click)="toggleAnalyticsAssistantPaneShowing()"
          [hidden]="!isAnalyticsAssistantEnabled"
          color="dark"
          fill="clear"
          ngxTippy="Ask AI questions about your report conversation data (beta)"
          class="margin-right-5 button-dark-border"
        >
          <ion-icon name="sparkles-outline"></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="button-dark-border"
          (click)="viewInInbox()"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            placement: 'bottom'
          }"
          data-tippy-content="View conversations in inbox"
        >
          <ion-icon
            name="file-tray-outline"
            style="font-size: 1.05rem"
          ></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="button-dark-border"
          (click)="copyLink()"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            placement: 'bottom'
          }"
          data-tippy-content="Copy link to report"
        >
          <ion-icon name="link-outline" style="font-size: 1.05rem"></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="button-dark-border"
          (click)="downloadCSV()"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            placement: 'bottom'
          }"
          data-tippy-content="Download as a CSV"
        >
          <ion-icon
            name="cloud-download-outline"
            style="font-size: 1.05rem"
          ></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="button-dark-border"
          (click)="openSaveReportModal()"
          [hidden]="savedReportId"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            placement: 'bottom'
          }"
          data-tippy-content="Save report view for future use"
        >
          <ion-icon name="save" class="filter-button-icon"></ion-icon>
          <span class="hidden-sm">Save...</span>
        </ion-button>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="flexed flex-space-between">
    <div class="main-content">
      <ion-grid>
        <ion-row>
          <!-- Chart controls and filters-->
          <ion-col size="12">
            <div class="flexed-align-center">
              <ion-button
                color="dark"
                fill="clear"
                class="button-dark-border btn-small"
                (click)="showDateRangeOptions()"
                [ngClass]="{
                  'button-round-left': dateRange.type === 'absolute'
                }"
              >
                <ion-icon name="calendar" class="filter-button-icon"></ion-icon>
                <span class="hidden-sm">{{ dateRange.label }}</span>
                <ion-icon
                  name="chevron-down-outline"
                  class="filter-button-caret"
                ></ion-icon>
              </ion-button>
              <ion-button
                color="dark"
                fill="clear"
                class="btn-small"
                (click)="showDateRangePicker()"
                *ngIf="dateRange.type === 'absolute'"
                style="margin-left: 0; margin-right: 0; --padding-end: 6px"
              >
                {{ startDate | date: "M/d/yyyy" }} –
                {{ endDate | date: "M/d/yyyy" }}
              </ion-button>
              <ion-button
                color="warning"
                class="btn-small"
                *ngIf="isDateRangeInvalid"
                shape="round"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  placement: 'bottom'
                }"
                data-tippy-content="Invalid date range"
              >
                <ion-icon name="warning-outline"></ion-icon>
              </ion-button>
              <ion-button
                color="dark"
                fill="clear"
                class="button-dark-border btn-small"
                (click)="showGroupByOptions()"
              >
                <ion-icon
                  name="bar-chart"
                  class="filter-button-icon"
                ></ion-icon>
                <span class="hidden-sm">{{ groupByFilterLabel }}</span>
                <ion-icon
                  name="chevron-down-outline"
                  class="filter-button-caret"
                ></ion-icon>
              </ion-button>
              <app-filter-button
                [options]="filterOptions"
                (didChange)="filtersDidChange($event)"
                [selected]="filters"
                [projectId]="authService.selectedProject?.id ?? undefined"
              ></app-filter-button>
            </div>

            <ion-card class="outline-card">
              <div style="margin: 15px 10px" class="hidden-sm">
                <p style="font-size: 0.8rem; opacity: 0.5; margin-left: 5px">
                  <strong>Results</strong> broken down by:
                </p>
                <ng-container *ngFor="let report of DIMENSION_OPTIONS">
                  <span
                    *appVar="tabIsActive(report) as isTabActive"
                    class="tab-nav-link"
                    [ngClass]="{ 'tab-nav-active': isTabActive }"
                    (click)="setDimension(report, $event)"
                    style="font-size: 0.7rem"
                  >
                    <ion-icon
                      [name]="
                        isTabActive ? report.icon : report.icon + '-outline'
                      "
                    ></ion-icon>
                    {{ report.label }}
                  </span>
                </ng-container>
              </div>
              <ion-card-content>
                <!-- Show total values when chart style is 'cards' -->
                <div *ngIf="chartStyle === 'cards'" class="cards-container">
                  <div class="cards-grid">
                    <ion-card
                      *ngFor="let item of totalValues"
                      class="card"
                      [ngClass]="{ 'totals-row': item.isTotalsRow }"
                    >
                      <div class="report-title">
                        <ion-icon
                          *ngIf="item.dimensionData?.icon"
                          [name]="item.dimensionData.icon"
                          [class]="item.dimensionData.iconClass"
                        ></ion-icon>
                        {{ item.label }}
                      </div>
                      <div class="report-stat">
                        {{ item.value | number }}
                      </div>
                    </ion-card>
                  </div>
                </div>

                <!-- Show chart when not showing cards -->
                <div
                  *ngIf="chartStyle !== 'cards'"
                  style="
                    position: relative;
                    height: 520px;
                    width: 100%;
                    margin: auto;
                  "
                >
                  <canvas
                    #chart
                    baseChart
                    [datasets]="chartData"
                    [labels]="chartLabels"
                    [options]="chartOptions"
                  >
                  </canvas>
                </div>
              </ion-card-content>
            </ion-card>
            <div style="text-align: center">
              <ion-button
                color="dark"
                fill="clear"
                class="btn-small fake-button"
                [disabled]="true"
              >
                Chart options:
              </ion-button>
              <ion-button
                color="dark"
                fill="clear"
                class="btn-small"
                (click)="changeUnit()"
                *ngIf="isTimeBasedMetric(chartType)"
              >
                <ion-icon
                  name="timer-outline"
                  class="padded-icon checkbox-icon"
                >
                </ion-icon>
                {{ unit.label }}
                <ion-icon
                  name="chevron-down-outline"
                  class="filter-button-caret"
                ></ion-icon>
              </ion-button>
              <ion-button
                color="dark"
                fill="clear"
                class="btn-small"
                (click)="showChartStyleOptions()"
              >
                <ion-icon
                  [name]="
                    chartStyle === 'bar'
                      ? 'stats-chart'
                      : chartStyle === 'cards'
                        ? 'grid'
                        : 'analytics'
                  "
                  class="filter-button-icon"
                ></ion-icon>
                <span style="font-weight: 600; text-transform: capitalize">{{
                  chartStyle
                }}</span>
                <ion-icon
                  name="chevron-down-outline"
                  class="filter-button-caret"
                ></ion-icon>
              </ion-button>
              <ion-button
                class="btn-small hidden-sm"
                fill="clear"
                color="dark"
                (click)="toggleLegendShowing()"
                *ngIf="chartStyle !== 'cards'"
              >
                <ion-icon
                  [name]="
                    shouldShowLegend ? 'checkmark-circle' : 'ellipse-outline'
                  "
                  class="padded-icon checkbox-icon"
                >
                </ion-icon>
                Show legend
              </ion-button>
              <ion-button
                class="btn-small"
                fill="clear"
                color="dark"
                (click)="toggleChartSmoothing()"
                [hidden]="chartStyle === 'bar' || chartStyle === 'cards'"
              >
                <ion-icon
                  [name]="
                    chartSmoothingEnabled
                      ? 'checkmark-circle'
                      : 'ellipse-outline'
                  "
                  class="padded-icon checkbox-icon"
                >
                </ion-icon>
                Line smoothing
              </ion-button>
              <ion-button
                class="btn-small"
                fill="clear"
                color="dark"
                (click)="toggleBusinessHoursOnly()"
              >
                <ion-icon
                  [name]="
                    businessHoursOnly ? 'checkmark-circle' : 'ellipse-outline'
                  "
                  class="padded-icon checkbox-icon"
                >
                </ion-icon>
                Working hours only
              </ion-button>
            </div>
          </ion-col>
          <!-- Table view -->
          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title">
                <h3>Results</h3>
              </ion-card-title>
              <ngx-datatable
                class="material"
                [limit]="100"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="50"
                [scrollbarH]="true"
                [rows]="tabularDataWithTotals"
                [reorderable]="true"
                [rowClass]="getRowClass"
              >
                <ngx-datatable-column
                  name="{{ dimensionKey !== 'overall' ? dimensionLabel : '' }}"
                  prop="dimensionLabel"
                  [sortable]="false"
                  [frozenLeft]="true"
                  [width]="250"
                >
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <ion-icon
                      *ngIf="row.dimensionData?.icon"
                      [name]="row.dimensionData.icon"
                      [class]="row.dimensionData.iconClass"
                      style="margin-right: 5px"
                    ></ion-icon>
                    {{ row.dimensionData?.value ?? getYAxisLabel() }}
                  </ng-template>
                </ngx-datatable-column>
                <ng-container>
                  <ngx-datatable-column
                    *ngFor="let column of columns"
                    [name]="getColumnName(column)"
                    [prop]="column"
                    [sortable]="true"
                    [width]="115"
                  >
                    <ng-template let-value="value" ngx-datatable-cell-template>
                      {{ value | number }}
                    </ng-template>
                  </ngx-datatable-column>
                </ng-container>
                <ngx-datatable-column
                  name="Total"
                  prop="total"
                  [sortable]="true"
                  [width]="115"
                  *ngIf="showTotalColumn"
                >
                  <ng-template let-value="value" ngx-datatable-cell-template>
                    {{ value | number }}
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div
      class="right-col hidden-sm"
      [hidden]="!showAssistantPane"
      [ngClass]="{ expanded: assistantMessages?.length > 1 }"
    >
      <div class="assistant-chat-container">
        <div
          class="assistant-chat-header flex-space-between flexed-align-center"
        >
          <h3>AI Analytics Assistant β</h3>
          <div>
            <ion-button
              fill="clear"
              color="dark"
              class="btn-small header-button"
              (click)="clearAssistantChat()"
              *ngIf="assistantMessages?.length"
            >
              <ion-icon name="create-outline"></ion-icon>
            </ion-button>
            <ion-button
              fill="clear"
              color="dark"
              class="btn-small header-button"
              (click)="toggleAnalyticsAssistantPaneShowing()"
            >
              <ion-icon name="close"></ion-icon>
            </ion-button>
          </div>
        </div>
        <!-- Empty state when no messages -->
        <div class="assistant-empty-state" *ngIf="!assistantMessages?.length">
          <ion-icon
            name="sparkles"
            style="
              font-size: 48px;
              color: var(--ion-color-primary);
              margin-bottom: 16px;
            "
          ></ion-icon>
          <p>What insights can I help you with?</p>
          <ion-card class="message-composer-inner highlighted-card">
            <ion-textarea
              #assistantInputElement
              style="margin-top: 0px"
              rows="5"
              placeholder="Try asking something like: 'what were the most common issues, broken down by priority?'"
              [(ngModel)]="assistantInput"
              (keydown)="onAssistantEnterKey($event)"
            ></ion-textarea>
          </ion-card>
          <ion-button
            (click)="sendAssistantMessage()"
            [disabled]="!assistantInput?.trim() || isAssistantThinking"
            size="block"
          >
            <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
            Ask Question
          </ion-button>
        </div>

        <!-- Chat messages area -->
        <div
          class="assistant-messages"
          *ngIf="assistantMessages?.length || isAssistantThinking"
        >
          <div
            class="assistant-message"
            [ngClass]="{
              'user-message': message.role === 'user',
              'assistant-message-item': message.role === 'assistant'
            }"
            *ngFor="let message of assistantMessages"
          >
            <div class="message-content">
              <div
                class="message-text"
                [innerHTML]="convertToMarkdown(message.content)"
              ></div>
            </div>
          </div>

          <!-- Thinking indicator -->
          <div
            class="assistant-message assistant-message-item"
            *ngIf="isAssistantThinking"
          >
            <div class="message-content">
              <div class="message-text">
                <ion-spinner
                  name="dots"
                  style="margin-right: 8px; height: 10px"
                ></ion-spinner>
                <span>Assistant is thinking...</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Chat input area -->
        <div class="assistant-input-area" *ngIf="assistantMessages?.length">
          <div class="message-composer">
            <ion-card class="message-composer-inner outline-card">
              <ion-textarea
                #assistantChatInputElement
                style="margin-top: 0px"
                autoGrow
                rows="4"
                placeholder="Ask another question..."
                [(ngModel)]="assistantInput"
                (keydown)="onAssistantEnterKey($event)"
              ></ion-textarea>
              <ion-button
                class="no-margin button-icon"
                fill="clear"
                [disabled]="!assistantInput?.trim() || isAssistantThinking"
                (click)="sendAssistantMessage()"
                [color]="
                  !assistantInput?.trim() || isAssistantThinking
                    ? 'light'
                    : 'primary'
                "
              >
                <ion-icon
                  name="arrow-up-circle"
                  style="font-size: 1.5rem"
                ></ion-icon>
              </ion-button>
            </ion-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-modal
  [isOpen]="showSaveReportModal"
  class="saved-report-modal"
  (willDismiss)="onDismissSaveReportModal()"
>
  <ng-template>
    <ion-header class="modal-header">
      <ion-toolbar>
        <div class="modal-title">
          <h3>Create Saved Report</h3>
        </div>
        <ion-buttons slot="end">
          <ion-button
            fill="clear"
            shape="round"
            class="close-button"
            (click)="onDismissSaveReportModal()"
          >
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <ion-input
        [(ngModel)]="savedReportName"
        class="input-field"
        placeholder="Name your saved report"
      >
      </ion-input>
      <ion-list class="transparent-bg">
        <ion-item>
          <ion-label> Share this report with your team? </ion-label>
          <label class="switch" slot="end">
            <input type="checkbox" [(ngModel)]="savedReportShouldShare" />
            <span class="slider"></span>
          </label>
        </ion-item>
      </ion-list>
    </ion-content>
    <ion-footer>
      <ion-button
        style="margin: 15px"
        (click)="saveReport()"
        class="save-button"
        size="block"
        [disabled]="!savedReportName || isSaving"
      >
        Save
      </ion-button>
    </ion-footer>
  </ng-template>
</ion-modal>
